<div class="msa-arc">
  <!-- Header -->
  <div class="msa-arc__header">
    <div class="msa-arc__header-text">
      <h2 class="msa-arc__title">{{ title() }}</h2>
      <p class="msa-arc__subtitle">{{ subtitle() }}</p>
    </div>
    <div class="msa-arc__header-controls">
      <ng-content select="[header-controls]" />
      <select
        class="msa-arc__select"
        aria-label="Filtrar por cancha"
        [value]="selectedCourt()"
        (change)="onCourtFilterChange($event)"
      >
        <option value="all">Todas las canchas ({{ courts().length }})</option>
        @for (court of courts(); track court.name) {
          <option [value]="court.name">{{ court.icon }} {{ court.name }}{{ court.inactive ? ' (Inactiva)' : '' }}</option>
        }
      </select>
    </div>
  </div>

  <!-- Day view: calendar grid -->
  @if (view() === 'day') {
    @if (error() && !loading()) {
      <div class="msa-arc__error-state">
        <span class="msa-arc__error-icon" aria-hidden="true">⚠️</span>
        <p class="msa-arc__error-text">{{ errorMessage() }}</p>
        <lib-button label="Reintentar" variant="outline" color="neutral" size="sm" (clicked)="retry.emit()" />
      </div>
    } @else {
    <div class="msa-arc__grid-wrap">
      @if (loading()) {
        <div class="msa-arc__loading-overlay">
          <lib-loading-spinner />
          <span class="msa-arc__loading-text">Cargando disponibilidad...</span>
        </div>
      }
      <div class="msa-arc__grid" [style]="gridStyle()">
        @if (showHeaderHours()) {
          <div class="msa-arc__time-cell"></div>
          @for (h of timeHeaders(); track h.hour) {
            <div class="msa-arc__time-header" [class.msa-arc__time-header--night]="isNightHour(h.hour)">
              @if (isNightHour(h.hour)) {
                <svg class="msa-arc__night-icon" viewBox="0 0 24 24" fill="currentColor" width="11" height="11">
                  <path d="M21.75 15.5a9.5 9.5 0 01-11.96-11.9A9.5 9.5 0 1021.75 15.5z" />
                </svg>
              } @else {
                <span>{{ dayHourIcon }}</span>
              }
              {{ h.label }}
            </div>
          }
        }
        @for (row of filteredCourts(); track row.name; let ri = $index) {
          <div class="msa-arc__court-label" [class.msa-arc__court-label--inactive]="row.inactive">
            {{ row.icon }} {{ row.name }}
            @if (row.inactive) {
              <span class="msa-arc__inactive-badge">Inactiva</span>
            }
          </div>
          <div class="msa-arc__track" [class.msa-arc__track--inactive]="row.inactive" [style]="trackStyle()">
            @for (bk of row.blocks; track $index; let bi = $index) {
              <lib-agenda-block
                [label]="bk.label"
                [time]="bk.time"
                [status]="effectiveStatus(bk)"
                [bookable]="bk.bookable ?? false"
                [clickable]="!!config().interactiveOccupiedBlocks && bk.status !== 'cerrada'"
                [tooltip]="bk.tooltip ?? ''"
                [showLabel]="showInternalInfoOnBlock()"
                [showTime]="showTimeOnBlock()"
                [recurring]="showInternalInfoOnBlock() && !!bk.recurring"
                (clicked)="blockClicked.emit({ courtIndex: ri, blockIndex: bi })"
                [style.left.%]="(bk.start / totalHours()) * 100"
                [style.width]="blockWidth(bk)"
              />
            }
          </div>
        }
      </div>
    </div>
    }
  }

  <!-- Week view: projected content -->
  @if (view() === 'week') {
    <div class="msa-arc__view-content">
      <ng-content select="[week-view]" />
    </div>
  }

  <!-- Month view: projected content -->
  @if (view() === 'month') {
    <div class="msa-arc__view-content">
      <ng-content select="[month-view]" />
    </div>
  }

  <!-- Footer -->
  <div class="msa-arc__footer">
    <ng-content />
  </div>
</div>
